import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';
import { Period } from '../../feature/enums/reports';
import { Status } from '../../feature/enums/booking';
import { ExperienceType } from '../../feature/enums/experience';

export interface ReservationFilters {
    startDate?: Period;
    endDate?: Period;
    dateFrom?: string;
    dateTo?: string;
    moduleType?: ExperienceType[];
    status?: Status[];
    guest?: number;
    visitType?: 'business' | 'personal';
    bookerType?: 'guest' | 'owner';
}

const initialState: { value: ReservationFilters } = {
    value: {
        dateFrom: undefined,
        dateTo: undefined,
        moduleType: [],
        status: [],
        guest: undefined,
        visitType: undefined,
        bookerType: undefined,
    },
};

export const slice = createSlice({
    name: 'reservationFilters',
    initialState,
    reducers: {
        setReservationFilters: (state, action) => {
            Object.assign(state.value, action.payload);
        },
        resetReservationFilters: (state) => {
            state.value = { ...initialState.value };
        },
    },
});

export const { setReservationFilters, resetReservationFilters } = slice.actions;

export const selectReservationFilters = (state: RootState) =>
    state.reservationFilters.value;

export const ReservationFiltersReducer = slice.reducer;
